<template>
  <div>
    <b-form-group
      class="mb-3"
      id="cpf"
      label-for="input-cpf"
      :invalid-feedback="inputInvalid"
      :label="label"
      :state="state"
      :class="col"
    >
      <b-form-input
        id="input-cpf"
        v-model="cpf"
        v-mask="'###.###.###-##'"
        :placeholder="inputText"
        :disabled="disabled"
        :state="state"
        @blur="verificaCPF"
        autocomplete="off"
        trim
      >
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      label: String, // para dar nome ao campo
      inputText: String, // placeholder
      inputInvalid: String, // mensagem para campo invalido
      col: String, // definindo o tamanho do input na tela de acordo com cada caso
      disabled: Boolean, //para abilitar ou desabilitar o campo
      filtro: String, // envia dados do componente pai para o filho
      validado: Boolean // controla a cor dos campos
    },

  created() {
    if (this.filtro) {
      this.cpf = this.filtro;
    }
  },

    computed: {
      state(){
        if((this.validado || this.validado == false) || (this.estado == null || this.estado == false)){
          return this.validado
        }
        return this.estado
      }
    },

    data() {
      return {
        cpf: '',
        cpfSemMascara: '',
        estado: null
      }
    },

    methods: {
      verificaCPF(){
        this.cpfSemMascara = this.cpf.replace(/\W/g, "");
        if(this.cpfSemMascara.length === 0){
          this.estado = null
          return
        }
        if (this.cpfSemMascara == "00000000000" ||
          this.cpfSemMascara == "11111111111" ||
          this.cpfSemMascara == "22222222222" ||
          this.cpfSemMascara == "33333333333" ||
          this.cpfSemMascara == "44444444444" ||
          this.cpfSemMascara == "55555555555" ||
          this.cpfSemMascara == "66666666666" ||
          this.cpfSemMascara == "77777777777" ||
          this.cpfSemMascara == "88888888888" ||
          this.cpfSemMascara == "99999999999"
        ){
          this.estado = false
        } else {
          this.estado = this.validaCPF(this.cpfSemMascara)
        }
      },

      validaCPF(cpf){
        var soma = 0;
        var resto;
        for (var i = 1; i <= 9; i++)
          soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cpf.substring(9, 10)))
          return false;
        soma = 0;
        for (i = 1; i <= 10; i++)
          soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        resto = (soma * 10) % 11;
        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cpf.substring(10, 11)))
          return false;
        this.$emit("emitindoCPF", this.cpf);
        return true;
      }
    },
  }
</script>
